var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7508_13233)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.0002,
    rx: 9.16667,
    ry: 9.16667,
    fill: "url(#paint0_linear_7508_13233)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.0002,
    rx: 9.16667,
    ry: 9.16667,
    fill: "url(#paint1_linear_7508_13233)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7508_13233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9993 7.62998C12.727 7.49382 12.5062 7.27301 12.37 7.00068L11.0357 4.77785C10.5172 3.74072 9.44359 3.74072 8.92502 4.77785L7.62998 7.00068C7.49382 7.27301 7.27301 7.49382 7.00068 7.62998L4.77785 8.92502C3.74072 9.44359 3.74072 10.5172 4.77785 11.0357L7.00068 12.37C7.27301 12.5062 7.49382 12.727 7.62998 12.9993L8.92502 15.2221C9.44359 16.2593 10.5172 16.2593 11.0357 15.2221L12.37 12.9993C12.5062 12.727 12.727 12.5062 12.9993 12.37L15.2221 11.0357C16.2593 10.5172 16.2593 9.44359 15.2221 8.92502L12.9993 7.62998Z",
    fill: "url(#paint2_linear_7508_13233)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3558 10.3933C13.2707 10.138 13.2707 9.86199 13.3558 9.60669L13.9112 7.38351C14.2353 6.41119 13.5643 5.7402 12.592 6.0643L10.3933 6.64417C10.138 6.72927 9.86199 6.72927 9.60669 6.64417L7.40801 6.0643C6.4357 5.7402 5.7647 6.41119 6.08881 7.38351L6.64417 9.60669C6.72927 9.86199 6.72927 10.138 6.64417 10.3933L6.0643 12.592C5.7402 13.5643 6.41119 14.2353 7.38351 13.9112L9.60669 13.3558C9.86199 13.2707 10.138 13.2707 10.3933 13.3558L12.6165 13.9112C13.5888 14.2353 14.2598 13.5643 13.9357 12.592L13.3558 10.3933Z",
    fill: "url(#paint3_linear_7508_13233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7508_13233",
    x: 2,
    y: 3,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509804 0 0 0 0 0.364706 0 0 0 0 0.796078 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7508_13233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7508_13233",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7508_13233",
    x1: -3.74996,
    y1: -2.08317,
    x2: 17.5,
    y2: 24.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#825DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546389,
    stopColor: "#E663C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF756B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7508_13233",
    x1: 17.5,
    y1: 0.00016271,
    x2: 6.66671,
    y2: 13.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D66D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E663C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7508_13233",
    x1: 9.99999,
    y1: 4,
    x2: 9.99999,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7508_13233",
    x1: 14.0909,
    y1: 13.75,
    x2: 5.9091,
    y2: 5.90909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7508_13233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSidebar);
export default __webpack_public_path__ + "static/media/ai-sidebar.06a99cef7f4929863823e73c38e5f247.svg";
export { ForwardRef as ReactComponent };